// extracted by mini-css-extract-plugin
module.exports = {"root":"figure-module--root--2-Ux9"};